<template>
  <div class="page" v-if="can('message.show')">
    <h2 class="accent--text">
      <v-icon color="primary" class="ml-3" large>mdi-thumb-up-outline</v-icon>
        التفاعل مع المواد
      <back-button />
    </h2>
    <hr class="my-5 header-divider" />

    <!-- RECORDS -->
    <v-card class="py-4">
      <v-card-text>
        <v-timeline align-top dense>
          <v-timeline-item
            small
            color="grey"
            :key="`${record.user_id}_${record.article_id}`"
            v-for="record in records"
          >
            <p>
              <strong>{{ (new Date(record.created_at)).toLocaleString() }}</strong>
              <span class="mx-2">|</span>
              قام المستخدم
              <span class="deep-orange--text"><strong>{{ record.user && record.user.email }}</strong></span>
              بالتفاعل مع المادة
              <a
                v-if="record.article"
                :href="`${websiteUrl}/article?article_id=${record.article.id}`"
                class="blue--text text--darken-3"
              ><strong>{{ record.article.title_text }}</strong></a>
            </p>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-card>
    
    <!-- PAGINATION -->
    <div class="text-center mt-7">
      <v-pagination
        total-visible="7"
        circle
        :value="parseInt(filters.page)"
        :length="totalPages"
        @input="$router.replace({ query: { ...$route.query, page: $event } })"
      ></v-pagination>
    </div>
  </div>
</template>


<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'contact-us',

  data: function () {
    return {
      table: {
        headers: [
          {
            value: 'id',
            text: 'مسلسل'
          },
          {
            value: 'email',
            text: 'البريد الإلكتروني'
          },
          {
            value: 'page',
            text: 'المسار'
          },
          {
            value: 'created_at',
            text: 'تاريخ الإضافة'
          },
          {
            value: 'controls',
            text: 'اعدادات'
          }
        ],
        loading: false
      },

      websiteUrl: process.env.VUE_APP_WEBSITE_BASE_URL
    }
  },


  computed: {
    ...mapState('likes', ['records', 'filters', 'totalPages']
    )
  },


  watch: {
    '$route': {
      async handler(route) {
        if (!route.query.page) {
          await this.$router.replace({ query: { ...route.query, page: 1 } });
          return;
        }

        this.SET_FILTERS(route.query);
        this.fetchRecords();
      },
      deep: true,
      immediate: true,
    }
  },


  methods: {
    ...mapMutations(
      'likes', ['SET_CURRNET_RECORD', 'SET_FILTERS']
    ),

    fetchRecords() {
      this.table.loading = true;

      this.$store.dispatch('likes/fetchRecords')
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر جلب البيانات, يرجي التأكد من حالة الشبكة',
            color: 'accent'
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    }
  }
}
</script>
